$(document).ready(function() {
    if ($(".container-fTrabajo-client")[0]) {
        let tableClient;
        let ser = {
            prodS:[],
            services:{},
            active: [],
            inactive: [],
            select: [],
            works:[]
        };

        let user = {
            miembros:[],
            active: [],
            inactive: [],
            select: []
        };

        function activeModals_(e) {
            const ext = ["xlsx", "pdf", "jpeg", "png", "doc"];

            const datos = $(e.target).parents(".container-contact-client");

            const modals = $(".modalDocument").modal();
            instance = M.Modal.getInstance(modals[0]);
            instance.options.dismissible = false;
            const elModal = instance.$el[0];
            instance.open();

            instance.options.onCloseStart = function() {
                //console.log("cerrar");
                $(".containerAddUser")[0].innerHTML = "";
                ser.select = [];
                user.select = {};
                $("#selectUser")
                    .children("option[value=null]")
                    .attr("selected", "");
                $("#selectFunc")
                    .children("option[value=null]")
                    .attr("selected", "");
            };
        }

        $("#imgAddM").click(activeModals_);
        $("#modalDocument > div.modal-footer > div > a").mouseup(function() {
            $("#modalDocument > div.modal-footer > div > a").attr(
                "disabled",
                ""
            );
            $.ajax({
                url: https + "addWorkFlows",
                method: "POST",
                data: {
                    idViewsCliPros: $("#idViewsCliPros").val(),
                    type_user: $("#type_user").val(),
                    iduser: $("#iduser").val(),
                    user: user.select.user.id,
                    ser: ser.select
                },

                beforeSend: function() {},
                success: function(data) {
                    if ($.trim(data[0]) == "1") {
                        console.log(data);
                        instance.close();

                        $(
                            "#modalDocument > div.modal-footer > div > a"
                        )[0].removeAttribute("disabled");

                        $("#selectUser")[0].removeAttribute("disabled");
                        //$("#selectFunc").val();

                        const ser_=data.ser;
                        const user_=data.user;
    
                        ser.prodS = data.prodS;
                        ser.services= ser_.services;
                        ser.services= ser_.services;
                        ser.active= ser_.active;
                        ser.inactive= ser_.inactive;
    
                        user.miembros= user_.miembros;
                        user.active= user_.active;
                        user.inactive= user_.inactive;

                        for (const key in ser.active) {
                            if (ser.active.hasOwnProperty(key)) {
                                const element = ser.active[key];
                                $("#selectFunc")
                                .children("option[value="+element+"]")
                                .remove();

                                
                            }
                        }

                        //validarUserAndSer();
                    } else if ($.trim(data) == "2") {
                        swal({
                            text: "No tiene los permisos necesarios",
                            icon: imageURL,
                            button: "OK!"
                        });
                    } else {
                        swal({
                            text: "Error, hubo problemas",
                            icon: imageURL,
                            button: "OK!"
                        });
                    }
                }
            });
        });

        /*

<ul class="collapsible">
        <li>
            <div class="collapsible-header valign-wrapper">
                <img src="{{asset('img/avatar/7.jpg')}}" alt="">
                <p> Hans Madera </p>
            </div>
            <div class="collapsible-body">
                <div class="row">
                    <div class="col s12">
                        Lorem ipsum dolor sit amet.
                    </div>
                    <div class="col s12">
                        Lorem ipsum dolor sit amet.
                    </div>                                
                </div>
            </div>
        </li>
</ul> 

*/

        $("#selectUser").click(function() {
            const idSearch = Object.keys(user.active).indexOf(this.value);
            if (this.value == "null") {
                return;
            }
            if (idSearch != -1) {
            } else {
                const elm = user.miembros[(this.value-1)];

                const ul = $("<ul>")
                    .attr("id", "idUsp_" + elm.id)
                    .addClass("collapsible")
                    .appendTo($(".containerAddUser"));

                const li = $("<li>").appendTo(ul);

                const div1 = $("<div>")
                    .addClass("collapsible-header valign-wrapper")
                    .appendTo(li);

                $("<img>")
                    .attr("src", https + elm.photo)
                    .appendTo(div1);
                $("<p>")
                    .text(elm.name)
                    .appendTo(div1);

                const div2 = $("<div>")
                    .addClass("collapsible-body")
                    .appendTo(li);

                const rowDiv = $("<div>")
                    .addClass("row")
                    .appendTo(div2);
                user.select.elm = rowDiv;

                user.select.user = elm;
                //SelectInactivo("#selectUser", this.value);
                $("#selectUser").attr("disabled", "");

                //console.log(elm);
            }
        });

        function SelectInactivo(obj, value) {
            //console.log($(obj).children("option[value="+value+"]"));
            $(obj)
                .children("option[value=" + value + "]")
                .attr("disabled", "")
                .css({
                    color: "#494949"
                });

        }

        $("#selectFunc").click(function() {
            //console.log(this.value);
            const serAct= ser.active == null ? ['']:ser.active;
            const idSearch = Object.keys(serAct).indexOf(this.value);
            if (this.value == "null" || user.select.elm == undefined) {
                $("#selectFunc")
                    .children("option[value=null]")
                    .attr("selected", "");
                return;
            }
            if (idSearch != -1) {
            } else {
                //console.log(user.select.elm);
                const elm = ser.services[(this.value-1)];
                $("<div>")
                    .attr("id", "sp_" + elm.id)
                    .addClass("col s12")
                    .text(elm.name)
                    .appendTo(user.select.elm);
                ser.select.push(this.value);
                SelectInactivo("#selectFunc", this.value);
                $("#selectFunc")
                    .children("option[value=null]")
                    .attr("selected", "");
            }
            $(document).ready(function() {
                $(".collapsible").collapsible();
            });
        });


        $.ajax({
            url: https + "getWorkFlows",
            method: "POST",
            data: {
                idViewsCliPros: $("#idViewsCliPros").val(),
                type_user: $("#type_user").val(),
                iduser: $("#iduser").val()
            },
            beforeSend: function() {},
            success: function(data) {
                if ($.trim(data[0]) == "1") {
                    const ser_=data.ser;
                    const user_=data.user;

                    ser.prodS = data.prodS;
                    ser.services= ser_.services;
                    ser.services= ser_.services;
                    ser.active= ser_.active;
                    ser.inactive= ser_.inactive;
                    ser.works= ser_.works;

                    user.miembros= user_.miembros;
                    user.active= user_.active;
                    user.inactive= user_.inactive;

                    console.log(data);
                    validarUserAndSer();
                    addMienbro();
                } else if ($.trim(data) == "2") {
                    swal({
                        text: "No tiene los permisos necesarios",
                        icon: imageURL,
                        button: "OK!"
                    });
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!"
                    });
                }
            }
        });

        function addMienbro(){
            
            for (const key in ser.works) {
                if (ser.works.hasOwnProperty(key)) {
                    const element = ser.works[key];
                    
                    const userAct= user.miembros == null ? ['']:user.miembros;
                    
                    const id=parseInt(key)-1;

                    if(userAct.hasOwnProperty(id)){
                        console.log(userAct[id]);
                    }
                }
            }
        }

        function validarUserAndSer() {
            for (const key in ser.services) {
                if (ser.services.hasOwnProperty(key)) {
                    const element = ser.services[key];
                    const serAct= ser.active == null ? ['']:ser.active;
                    if(serAct.indexOf(element.id)==-1){
                        $("<option>")
                        .attr("value", element.id)
                        .text(element.name)
                        .appendTo($("#selectFunc"));
                    }
                }
            }

            for (const key in user.miembros) {
                if (user.miembros.hasOwnProperty(key)) {
                    const element = user.miembros[key];
                    
                    $("<option>")
                        .attr("value", element.id)
                        .text(element.name)
                        .appendTo($("#selectUser"));
                }
            }            
        }

        $(document).ready(function () {
           
            tableClient = $(".tableFTrabajo").DataTable({
                "ordering": false,
                searching: false,
                paging: false,
                info: false,
            });  
            
                     
        })

    }
});
